import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import statesReducer from './slices/statesSlice';
import citiesReducer from './slices/citiesSlice';
import usersReducer from './slices/usersSlice';
import dashboardReducer from './slices/dashboardSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import cmsReducer from './slices/cmsSlice';
import helpSupportReducer from './slices/helpSupportSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    states: statesReducer,
    cities: citiesReducer,
    users: usersReducer,
    dashboard: dashboardReducer,
    subscription: subscriptionReducer,
    cms: cmsReducer,
    helpSupport: helpSupportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
